module.exports = __webpack_public_path__ + "static/media/pop_upon-inalambrico.f9272e54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-inalambrico/pop_upon-inalambrico.jpg
// module id = 614
// module chunks = 0